<script setup lang="ts">
  import { Switch } from "@/components/ui/switch";

  const showTranslations = defineModel<boolean>({ required: true });
</script>

<template>
  <div class="inline-flex items-center gap-1.5 text-xs">
    <button
      type="button"
      class="transition-colors"
      :class="showTranslations ? 'text-muted-foreground hover:text-foreground' : 'font-medium text-foreground'"
      @click="showTranslations = false">
      Raw
    </button>
    <Switch
      :model-value="showTranslations"
      aria-label="Show translated verbatims"
      @update:model-value="showTranslations = $event" />
    <button
      type="button"
      class="transition-colors"
      :class="showTranslations ? 'font-medium text-foreground' : 'text-muted-foreground hover:text-foreground'"
      @click="showTranslations = true">
      Translated
    </button>
  </div>
</template>
